import {
  ArcadeIcon,
  BetnanaOriginalsIcon,
  BingoIcon,
  BlackjackIcon,
  CasinoIcon,
  DiamondCardIcon,
  DiceIcon,
  FireIcon,
  GugulOriginalsIcon,
  InstantGameIcon,
  KenoIcon,
  LiveDealerIcon,
  PlinkoIcon,
  PopularGamesIcon,
  RocketIcon,
  RouletteIcon,
  ShootingIcon,
  Slot7Icon,
  TableGameIcon,
  VatanOriginalsIcon,
  VirtualsIcon,
} from '@repo/icons';
import { memoize } from 'lodash-es';
import { GameListResponseType } from '@/lib/fetch';

export const getCasinoCategoryIcon = (type?: string) => {
  type = type?.toLowerCase();

  switch (type) {
    case 'vatan-game-originals':
    case 'hazarat-game-originals':
    case 'skibet-originals':
    case 'xbet-originals':
    case 'asabet-originals':
      return VatanOriginalsIcon;
    case 'betnana-originals':
      return BetnanaOriginalsIcon;
    case 'gugul-originals':
      return GugulOriginalsIcon;
    case 'popular':
      return PopularGamesIcon;
    case 'new':
      return FireIcon;
    case 'slots':
      return Slot7Icon;
    case 'plinko':
      return PlinkoIcon;
    case 'crash':
      return RocketIcon;
    case 'live':
      return LiveDealerIcon;
    case 'dice':
      return DiceIcon;
    case 'roulette':
      return RouletteIcon;
    case 'baccarat':
      return DiamondCardIcon;
    case 'blackjack':
      return BlackjackIcon;
    case 'tablegames':
      return TableGameIcon;
    case 'shooting':
      return ShootingIcon;
    case 'instantgame':
      return InstantGameIcon;
    case 'arcade':
      return ArcadeIcon;
    case 'poker':
      return CasinoIcon;
    case 'virtual':
      return VirtualsIcon;
    case 'keno':
      return KenoIcon;
    case 'bingo':
      return BingoIcon;
    default:
      return CasinoIcon;
  }
};

/**
 * Group games by category type.
 */
export const groupGamesByType = memoize<(games: GameListResponseType, type: string) => GameListResponseType>(
  (games, type) => games?.filter?.((game) => game.gameType?.includes(type)),
  (_games, type) => type // revalidate cache by type
);
